module.exports = __webpack_public_path__ + "static/img/img-3.07714ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/img-3.png
// module id = K2Kx
// module chunks = 10